import { ReactNode } from 'react';

import { DiamondExclamationIcon, mergeStyles } from '../..';

const ICON_STYLE = 'mr-1 fill-red-600';
const DEFAULT_STYLE = 'flex flex-row';
const TEXT_COLOR = { error: 'text-red-600', helper: 'text-gray-600' };
const FONT_SIZE = { medium: 'text-sm', large: 'text-base' };
const PADDING = { medium: 'py-1', large: 'py-2' };
const ICON_SIZE = { medium: 'size-4 mt-0.5', large: 'size-4.5 mt-0.75' };

export interface HelperTextProps {
  /** Additional class names */
  className?: string;
  /** Controls font size, icon size, & padding size */
  size?: 'medium' | 'large';
  /** Error to display */
  display: string | ReactNode;
  /** Render error */
  visible?: boolean;
}

export interface ErrorTextProps extends HelperTextProps {
  /** To be used with type "error", if true show the error icon */
  showIcon?: boolean;
}

export interface FormHelperTextProps extends ErrorTextProps {
  /** Controls font color, only "error" supports showIcon */
  type: 'error' | 'helper';
}

export const FormHelperText = ({
  className,
  showIcon = true,
  size = 'medium',
  display = 'This field is required',
  visible = true,
  ...props
}: FormHelperTextProps) => {
  const { type } = props;
  const styling = mergeStyles([DEFAULT_STYLE, TEXT_COLOR[type], FONT_SIZE[size], PADDING[size], className]);

  return (
    <>
      {visible && (
        <div className={styling}>
          {type == 'error' && showIcon && (
            <div className="flex flex-col">
              <DiamondExclamationIcon className={`${ICON_STYLE} ${ICON_SIZE[size]}`} />
            </div>
          )}
          <div className={`flex flex-col text-wrap text-left`}>{display}</div>
        </div>
      )}
    </>
  );
};

export default FormHelperText;
